var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("nav-bar", {
        attrs: { info: _vm.info, notifications: _vm.notifications },
      }),
      _vm._v(" "),
      _c("router-view", {
        key: _vm.$route.fullPath,
        attrs: { info: _vm.info, notifications: _vm.notifications },
      }),
      _vm._v(" "),
      _c("error-messages"),
      _vm._v(" "),
      _c("page-footer"),
      _vm._v(" "),
      _vm.unauthorised ? _c("unauthorised-modal") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }